<ion-content class="ion-padding">
    <h4 aria-level="2" id="radio-group-label" class="ion-text-center" [innerHTML]="'TRIPS_ALERT_ADDED_TRIP_TYPE_TITLE' | translate"></h4>
    <p class="ion-text-center" [innerHTML]="'TRIPS_ALERT_ADDED_TRIP_TYPE_SUBTITLE' | translate"></p>

    <ion-radio-group (ionChange)="validate($event.target.value)" [(ngModel)]="tripType">
        <ion-list role="group" aria-labelledby="radio-group-label">
            <ion-item button aria-labelledby="radio-label-loop" (click)="setType('LOOP')">
                <ion-avatar slot="start" aria-hidden="true">
                    <img id="img-loop" src="assets/imgs/trip-type-loop.svg">
                </ion-avatar>
                <ion-label id="radio-label-loop" [innerHTML]="'TRIPS_ALERT_ADDED_TRIP_TYPE_LOOP' | translate"></ion-label>
                <ion-radio mode="ios" [value]="'LOOP'" aria-hidden="true"></ion-radio>
            </ion-item>
            <ion-item button aria-labelledby="radio-label-round" (click)="setType('ROUND_TRIP')">
                <ion-avatar slot="start" aria-hidden="true">
                    <img id="img-round-trip" src="assets/imgs/trip-type-round-trip.svg">
                </ion-avatar>
                <ion-label id="radio-label-round" [innerHTML]="'TRIPS_ALERT_ADDED_TRIP_TYPE_ROUND_TRIP' | translate"></ion-label>
                <ion-radio mode="ios" [value]="'ROUND_TRIP'" aria-hidden="true"></ion-radio>
            </ion-item>
            <ion-item button aria-labelledby="radio-label-one-way" (click)="setType('ONE_WAY')">
                <ion-avatar slot="start" aria-hidden="true">
                    <img id="img-one-way" src="assets/imgs/trip-type-one-way.svg">
                </ion-avatar>
                <ion-label id="radio-label-one-way" [innerHTML]="'TRIPS_ALERT_ADDED_TRIP_TYPE_ONE_WAY' | translate"></ion-label>
                <ion-radio mode="ios" [value]="'ONE_WAY'" aria-hidden="true"></ion-radio>
            </ion-item>
        </ion-list>
    </ion-radio-group>

    <div class="button-row">
        <ion-col size="6"><ion-button fill="clear" color="text-primary" (click)="dismiss()" [innerHTML]="'BUTTON_CANCEL' | translate"></ion-button></ion-col>
        <ion-col size="6"><ion-button fill="clear" color="text-primary" (click)="next()"    [innerHTML]="'BUTTON_NEXT' | translate" [disabled]="valid === false"></ion-button></ion-col>
    </div>
</ion-content>
